import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';
import RootLayout from '@/layouts/root/RootLayout';
import { LoadingProgress } from '@/components/loader';

// Add public page imports here as needed
// Copy from full-version/src/routes/public.jsx

const LAYOUT_CONTENT = (
  <RootLayout>
    <Suspense fallback={<LoadingProgress />}>
      <Outlet />
    </Suspense>
  </RootLayout>
);

export const PublicRoutes = [
  {
    element: LAYOUT_CONTENT,
    children: [
      // Add public routes here as needed
      // Example:
      // {
      //   path: 'about-us',
      //   element: <AboutUs />
      // }
    ]
  }
];
